import { useQuery } from 'react-query';

import { PermissionOverride } from '../types/backend-dto-types';
import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import useGetFetchConfig from '@/api/useGetFetchConfig';

export const useGetPermissionOverrides = (matterId: string, options?: { enabled?: boolean }) => {
  const { fetchConfigGET } = useGetFetchConfig();

  return useQuery<PermissionOverride[]>(
    [QueryEntity.PermissionOverrides, { matterId }],
    async () => {
      const response = await fetch(`${APIBaseChronos}/api/matters/${matterId}/permission-overrides`, fetchConfigGET);
      if (!response.ok) {
        throw new Error('Failed to fetch matter-level permissions');
      }
      return response.json();
    },
    { enabled: !!matterId && (options?.enabled ?? true) },
  );
};
